import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './scss/style.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Results from './views/results';
import Game from './views/game';

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={Game} />
          <Route exact path="/results/:challenge" component={Results} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
